import { render, staticRenderFns } from "./BeButton.vue?vue&type=template&id=048cfbdd"
import script from "./BeButton.vue?vue&type=script&lang=js"
export * from "./BeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports